import styled from '@emotion/styled';

export const Footer = styled.footer`
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  bottom: 0;
  margin-top: 0;
  background: ${({ theme, bgColor }) =>
    bgColor ? theme.colors[bgColor] || bgColor : theme.colors.neutralMain};
  border: none;
  z-index: 100;
  padding: ${({ theme }) => `${theme.spacings[3]} ${theme.spacings[3]}`};
  /* padding-left: 0; */
  min-height: 72px;
`;

export const Container = styled.div`
  flex: 1;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const FooterContent = styled.div`
  max-width: 1200px;
  width: 100%;

  ${({ theme }) => theme.media.tablet} {
    padding-left: ${({ theme: { constants } }) =>
      constants.layout.side.leftPadding.tablet};
    padding-right: ${({ theme: { constants } }) =>
      constants.layout.side.leftPadding.tablet};
  }
  ${({ theme }) => theme.media.mobile} {
    padding-left: ${({ theme: { constants } }) =>
      constants.layout.side.leftPadding.mobile};
    padding-right: ${({ theme: { constants } }) =>
      constants.layout.side.leftPadding.mobile};
  }
`;
